export default __webpack_public_path__ + "static/media/AppRemoteH.f1d7bdba.png";